module.exports = "label input[type='file'] {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\ninput[type='file'] {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/import/fcd/import-fcd.component.scss
// module id = ./src/app/admin/import/fcd/import-fcd.component.scss
// module chunks = main